// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"2421eb7a","272":"3b5fbe37"}[chunkId] + ".chunk.css";
};